import React, { Component } from 'react';
import { connect } from 'react-redux';
import qs from 'query-string';

// action을 사용하면 epic을 통해 앱에 영향을 미친다
// 쿠폰 정보를 가져오는 api 까지는 그냥 api를 사용해 영향을 최소화하자
import * as couponAPI from 'shared/apis/coupon.api';
import { pushModal } from 'shared/actions/modal.action';
import { postCoupon } from 'shared/actions/coupon.action';

import storage from 'shared/utils/storage';

function fetchCouponSuccess({ couponInfo }) {
  return { type: 'FETCH_COUPON_SUCCESS', payload: { couponInfo } };
}
function fetchCouponFailure() {
  return { type: 'FETCH_COUPON_FAILURE' };
}

/**
 * Supports Braze Coupon popup
 * main job is setting window.couponBridge
 */
function withCoupon(WrappedComponent) {
  @connect(
    state => ({
      user: state.shared.auth.user,
      couponFreeLectureInfo: state.shared.coupon.couponFreeLectureInfo,
    }),
    {
      pushModal,
      postCoupon,
    },
  )
  class WithCoupon extends Component {
    componentDidMount() {
      window.addEventListener('message', e => {
        function dispatch(action) {
          e.source.postMessage(action, '*');
        }

        if (!e.data?.source?.match('@qualson/braze-coupon')) return;
        console.log('eee', e.data);
        const action = e.data;
        this.brazeCouponReducer(dispatch, action);
      });
    }

    brazeCouponReducer(dispatch, action) {
      const { type, payload } = action;
      switch (type) {
        case 'FETCH_COUPON_REQUEST':
          (async () => {
            try {
              const couponInfo = await this.fetchCoupon(payload);
              dispatch(fetchCouponSuccess({ couponInfo }));
            } catch (e) {
              dispatch(fetchCouponFailure());
            }
          })();
          break;
        case 'DOWNLOAD_COUPON_REQUEST':
          this.downloadCoupon(payload);
          break;
        default:
          return;
      }
    }

    fetchCoupon = async data => {
      // 쿠폰 코드가 주어지는 경우
      let { couponCode } = data;

      // 쿠폰 링크를 통해 들어온 경우
      if (couponCode === 'COUPON_CODE') {
        const query = qs.parse(window.location.search);
        couponCode = query.couponcode;
      }
      
      if (couponCode === 'EXPERIENCE_LECTURE') {
        // get couponCode from api
      }

      // 무료체험 쿠폰인 경우, 다른 방식으로 쿠폰을 받아와야 한다.
      // 매번 다른 쿠폰이 발급될 수 있기 때문이다.
      if (couponCode === 'EXPERIENCE_LECTURE') {
        // 이건 테스트용 쿠폰코드 고정
        // TODO: api를 사용해야 한다.
        couponCode = this.props.couponFreeLectureInfo?.couponNumber;
      }

      if (!couponCode) {
        throw Error('Could not found couponCode');
      }

      const response = await couponAPI
        .getCoupon$({ code: couponCode })
        .toPromise();
      if (response.code !== 200) {
        throw Error('Fetch coupon failed');
      }

      const {
        useBeforeImageUrl,
        useAfterImageUrl,
        viewEndDateAsString,
        discount,
        discountUnit,
      } = response.result;

      return {
        couponCode,
        couponImageUrl: useBeforeImageUrl,
        couponSuccessImageUrl: useAfterImageUrl,
        downloadEndDate: viewEndDateAsString, // 사용자가 쿠폰을 받을 수 있는 기한, (!== 쿠폰의 사용기한)
        couponPrice: discount,
        couponPriceUnit: discountUnit,
      };
    };

    downloadCoupon = async data => {
      const { couponCode, couponSuccessImageUrl } = data;
      storage.set('welcome:couponImage', couponSuccessImageUrl);

      // 쿠폰 발급 요청
      // 쿠폰을 받으려면 로그인이 필요하다
      const { user } = this.props;

      if (user.type === 'GUEST') {
        // 로그인 후 쿠폰 발급을 위해 저장
        storage.set('welcome:coupon', couponCode);
        this.props.pushModal({ type: 'Login' });

        // 남은 동작은 auth epic에 맡긴다
        return;
      }
      // 이미 로그인한 유저라면
      // 쿠폰 코드만 전달하면 서버가 쿠키에서 사용자 정보를 읽어 자동으로 내 쿠폰에 등록할 예정.
      this.props.postCoupon(couponCode);
    };

    render() {
      // emit injected props
      const { coupon, getCoupon, postCoupon, ...componentProps } = this.props;
      return <WrappedComponent {...componentProps} />;
    }
  }
  return WithCoupon;
}

export default withCoupon;
